import { render, staticRenderFns } from "./conterno-fantino.vue?vue&type=template&id=d98e0752&scoped=true"
import script from "./conterno-fantino.vue?vue&type=script&lang=js"
export * from "./conterno-fantino.vue?vue&type=script&lang=js"
import style0 from "./conterno-fantino.vue?vue&type=style&index=0&id=d98e0752&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d98e0752",
  null
  
)

export default component.exports